import InfoCards from "../InfoCards/InfoCards";
import classes from "./WhoWeHelp.module.scss";
import { ReactComponent as FinancialInstitutions } from "../../../assets/icons/clemAi/financialInstitutions.svg";
import { ReactComponent as ReDevelopers } from "../../../assets/icons/clemAi/reDevelopers.svg";
import { ReactComponent as Consumers } from "../../../assets/icons/clemAi/consumers.svg";
import { ReactComponent as Storage } from "../../../assets/icons/clemAi/storage.svg";

function WhoWeHelp() {
  return (
    <div className={classes.container}>
      <div className={classes.title}>Who we help</div>

      <div className={classes["infocards-normal-view"]}>
        <InfoCards
          content={[
            {
              title: "Financial Institutions",
              icon: <FinancialInstitutions />,
              description:
                "Enhance bankability through increased profits powered by AI.",
            },
            {
              title: "RE Developers",
              icon: <ReDevelopers />,
              description:
                "We enhance profitability through additional cashflows powered by AI.",
            },
            {
              title: "Consumers",
              icon: <Consumers />,
              description:
                "Manage cost & enhance profitability with customised power contracts that achieve climate goals, powered by AI.",
            },
            {
              title: "Storage",
              icon: <Storage />,
              description:
                "Optimise battery operations to maximise profitability powered by AI.",
            },
          ]}
        />
      </div>

      <div className={classes["mobile-view-infocards"]}>
        <InfoCards
          content={[
            {
              title: "Financial Institutions",
              icon: <FinancialInstitutions />,
              description:
                "Enhance bankability through increased profits powered by AI.",
            },
            {
              title: "RE Developers",
              icon: <ReDevelopers />,
              description:
                "We enhance profitability through additional cashflows powered by AI.",
            },
          ]}
        />

        <InfoCards
          content={[
            {
              title: "Consumers",
              icon: <Consumers />,
              description:
                "Manage cost & enhance profitability with customised power contracts that achieve climate goals, powered by AI.",
            },
            {
              title: "Storage",
              icon: <Storage />,
              description:
                "Optimise battery operations to maximise profitability powered by AI.",
            },
          ]}
        />
      </div>
    </div>
  );
}

export default WhoWeHelp;
